import React from "react"
import {Helmet} from "react-helmet"

export default props =>
<Helmet>
  <meta charSet="utf-8" />
  <title>GitHub Customer Experience Research</title>
  <link rel="canonical" href="http://cxr.github.com" />
  <link rel="icon" href="https://user-images.githubusercontent.com/334891/57234151-1400b100-6fee-11e9-95f2-5539e3e28e6c.png" />
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <meta property="og:title" content="GitHub Customer Experience Research" />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://cxr.github.com" />
  <meta property="og:description" content="Help us shape the future of GitHub" />
  <meta
    property="og:image"
    content="https://user-images.githubusercontent.com/334891/57989042-52bd4f00-7a63-11e9-993c-3212b84745ac.png"
  />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:site" content="@github" />
</Helmet>